import { render } from "./Labels.vue?vue&type=template&id=4a28e2c5&scoped=true&ts=true"
import script from "./Labels.vue?vue&type=script&lang=ts"
export * from "./Labels.vue?vue&type=script&lang=ts"

import "./Labels.vue?vue&type=style&index=0&id=4a28e2c5&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a28e2c5"]])

export default __exports__